module.exports = __webpack_public_path__ + "img/ailpay.2159026f.jpg";